module.exports = __webpack_public_path__ + "img/circle_ADD_new_etap.721f7a7f.svg";